import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import {initReactI18next} from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import * as Config from "./Config";
import { defineLang }  from "./lang";

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: {
                    lang: defineLang.en.lang,
                    currency: defineLang.en.currency,
                    currencySymbol: defineLang.en.currencySymbol,
                    notfound: defineLang.en.notfound,
                    titLng: defineLang.en.titLng,
                    welcome: defineLang.en.welcome,
                    title: defineLang.en.title,
                    login: defineLang.en.login,
                    logout: defineLang.en.logout,
                    navigation: defineLang.en.navigation,
                    validation: defineLang.en.validation,
                    notification: defineLang.en.notification,
                    paginate: defineLang.en.paginate,
                    translate: defineLang.en.translate,
                    placeHolderForm: defineLang.en.placeHolderForm,
                    action: defineLang.en.action,
                    permission: defineLang.en.permission,
                    item: defineLang.en.item,
                    orderGolf: defineLang.en.orderGolf,
                }
            },
            vi: {
                translation: {
                    lang: defineLang.vi.lang,
                    currency: defineLang.vi.currency,
                    currencySymbol: defineLang.vi.currencySymbol,
                    notfound: defineLang.vi.notfound,
                    titLng: defineLang.vi.titLng,
                    welcome: defineLang.vi.welcome,
                    title: defineLang.vi.title,
                    login: defineLang.vi.login,
                    logout: defineLang.vi.logout,
                    navigation: defineLang.vi.navigation,
                    validation: defineLang.vi.validation,
                    notification: defineLang.vi.notification,
                    paginate: defineLang.vi.paginate,
                    translate: defineLang.vi.translate,
                    placeHolderForm: defineLang.vi.placeHolderForm,
                    action: defineLang.vi.action,
                    permission: defineLang.vi.permission,
                    item: defineLang.vi.item,
                    orderGolf: defineLang.vi.orderGolf,
                }
            }
        },
        lng: i18n.language || window.localStorage.i18nextLng || Config.default.DEFAULT_LANG,
        fallbackLng: Config.default.DEFAULT_LANG,
        interpolation: {
            formatSeparator: ','
        },
        // react-i18next options
        react: {
            wait: true,
            omitBoundRerender: false,
            nsMode: 'default'
        },
    });

export default i18n;
